import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./cmmcsubnav.css"


const cmmcsubNav = ( { }) => {

    
    
    return (
        <section className="subnav" id="subNav">
            <div className="containfix">
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/cmmc/#Speakers">SPEAKERS</a>
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/cmmc/#Agenda">AGENDA</a>
                <a className="subNavButton" href="https://fedscoop.com/events/snglive/cmmc/wrap-up" target="_blank">WRAP-UP</a>
            </div>
         </section>
    )
}

export default cmmcsubNav